module.exports = __webpack_public_path__ + "img/男鞋4.67a3ffb2.png";